@if (formGroup) {
  <div
    [class.column-layout]="layout === 'column'"
    [formGroup]="formGroup"
    class="flex gap-8 w-full flex-1"
  >
    @if (columns$ | async; as columns) {
      <blaze-select
        [allowNone]="false"
        [errors]="columnErrors()"
        [filtered]="true"
        [multiselect]="false"
        [options]="columns"
        [showSelection]="true"
        [showTitleOnOptions]="!isTouchMode()"
        [useAppTheme]="useAppTheme"
        class="comparison-query-column"
        data-cy="ComplexFilter:ColumnSelector"
        filterPlaceholder="Field(s)"
        formControlName="column"
      />
    }
    @if (operators$ | async; as operators) {
      <blaze-select
        [allowNone]="false"
        [filtered]="false"
        [multiselect]="false"
        [options]="operators"
        [showSelection]="true"
        [useAppTheme]="useAppTheme"
        class="comparison-query-column"
        data-cy="ComplexFilter:OperatorSelector"
        formControlName="operator"
      />
    }
    @if (intelliConfig$ | async; as intelliConfig) {
      <div class="relative comparison-query-column">
        <blaze-intellisense
          (mousedown)="$event.stopPropagation()"
          (value)="onIntelliValueChange(formGroup, $event)"
          [config]="intelliConfig"
          [disabled]="disabled"
          [useAppTheme]="useAppTheme"
          [validationErrors]="valueErrors()"
          class="w-full"
          data-cy="ComplexFilter:ValueInput"
        />
      </div>
    }
  </div>
}
